// extracted by css-extract-rspack-plugin
export default {"submitButton":"dojLH"};